import { render, staticRenderFns } from "./FindBugForm.vue?vue&type=template&id=0fed722d&"
import script from "./FindBugForm.vue?vue&type=script&lang=js&"
export * from "./FindBugForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports